import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-e-ticket-desk',
  templateUrl: './e-ticket-desk.component.html',
  styleUrls: ['./e-ticket-desk.component.css']
})
export class ETicketDeskComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
